import { BaseModel } from "./base.model";

import { Order } from './order';
import { QuestionModel } from './question.model';
import { ChecklistModel } from './checklist.model';
import { AttachmentModel } from "./attachment.model";

export class ChecklistAnsweredModel extends BaseModel {
  boolean_percentage_visible: boolean;
  observation_visible: boolean;

  checklist_origin: ChecklistModel;
  checklist: string;

  filling_date: Date;
  institute: string;
  departament: string;
  user: string;
  weight: number;
  [x: string]: any;
  
  header_items: {
    description: string;
    response: string;
  }[];

  question_groups: {
    name: string;
    weight: number;

    questions: QuestionModel[];
  }[];

  real_responses: any[];

  attachments: AttachmentModel[];

  user_id: number;
  resp_id: number;

  user_observation: string;
  resp_observation: string;
  post_observation: string;

  orders: Order[];

  constructor(response?: ChecklistAnsweredModel) {
    super();

    this.observation_visible = response ? response.observation_visible || null : null;
    this.checklist_origin = response ? response.checklist_origin || null : null;
    this.filling_date = response ? response.filling_date || null : null;
    this.departament = response ? response.departament || null : null;
    this.checklist = response ? response.checklist || null : null;
    this.institute = response ? response.institute || null : null;
    this.weight = response ? response.weight || null : null;
    this.user = response ? response.user || null : null;

    this.header_items = response ? response.header_items || [] : [];
    this.question_groups = response ? response.question_groups || [] : [];

    this.real_responses = response ? response.real_responses || [] : [];

    this.user_id = response ? response.user_id || null : null;
    this.resp_id = response ? response.resp_id || null : null;
    this.user_observation = response ? response.user_observation || null : null;
    this.resp_observation = response ? response.resp_observation || null : null;
    this.post_observation = response ? response.post_observation || null : null;

    this.orders = response ? response.orders || [] : [];
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/checklist-answered.model.ts